import type { Reducer } from 'redux';
import ErrorRecord from '~/data/ErrorRecord';
import type { ExpediteInviteRequestsActions } from './types/actions.types';
import ExpediteInviteRequestsConstants from './constants';
import DataCreator from './data/data-creator';
import InviteRequestListRecord from './data/InviteRequestListRecord';

function getInitialState() {
  return new InviteRequestListRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<InviteRequestListRecord, ExpediteInviteRequestsActions> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case ExpediteInviteRequestsConstants.GET_INVITE_REQUESTS_REQUEST:
      return new InviteRequestListRecord({
        isLoading: true,
        selectedStatus: action.payload.inviteRequestStatus,
      });

    case ExpediteInviteRequestsConstants.GET_INVITE_REQUESTS_REQUEST_SUCCESS:
      return new InviteRequestListRecord({
        isLoading: false,
        selectedStatus: action.payload.inviteRequestStatus,
        statusCount: DataCreator.createStatusCount(action.response.statusCount),
        inviteRequests: DataCreator.createInviteRequestList(action.response.inviteRequests),
      });

    case ExpediteInviteRequestsConstants.GET_INVITE_REQUESTS_REQUEST_ERROR:
      return new InviteRequestListRecord({
        isLoading: false,
        isHandlingAction: false,
        selectedStatus: state.selectedStatus,
        statusCount: state.statusCount,
        inviteRequests: state.inviteRequests,
        error: new ErrorRecord(action.error),
      });

    default:
      return state;
  }
};

export default reducer;
